module.exports = __webpack_public_path__ + "static/media/iconLogout.b39e8455.svg";